import React, { useState,useEffect } from 'react';
import { Card,Accordion,Placeholder } from 'react-bootstrap';
const HelpFaq = () => 
{
    const appLanguage = localStorage.getItem('appLanguage') || 'en';
    const[isLoading, setLoading] = useState(true);
    const[Faqs,setFaqs]=useState([]);
    useEffect(()=>
    {
        const getFaqs = async () => 
        {
            try 
            {
                const response = await fetch(global.config.API_URL+"faq/all");
                const result = await response.json();
                setFaqs(result);
                if( global.config.IsPrint === false ) { console.info('Faqs : Result',result); }
            } 
            catch (error)
            {
                console.error('Faqs : Error', error.message);                
            }
            finally
            {
                setLoading(false);
            }
        };
        getFaqs();
    },[])
    return (
        <React.Fragment>
        {isLoading ? (
            <Accordion defaultActiveKey={[0]} alwaysOpen>
            {[...Array(12)].map((_,index)=>(
                <Accordion.Item eventKey={index} key={index}>
                    <Accordion.Header><Placeholder xs={6} /></Accordion.Header>
                    <Accordion.Body>
                        <Placeholder xs={12} />
                        <Placeholder xs={10} />
                        <Placeholder xs={8} />
                    </Accordion.Body>
                </Accordion.Item>
            ))}
            </Accordion>
            ) : (
            <React.Fragment>
            {Faqs.length > 0 ? (
                <Accordion defaultActiveKey={[0]} alwaysOpen>
                {Faqs.map((sf,index)=>(
                    <Accordion.Item eventKey={index} key={index}>
                        <Accordion.Header className='fw-bold'>
                            { appLanguage === 'hi' ? sf.sf_title_hi || sf.sf_title : sf.sf_title }
                        </Accordion.Header>
                        <Accordion.Body dangerouslySetInnerHTML={{__html: appLanguage === 'hi' ? sf.sf_ans_hi || sf.sf_ans : sf.sf_ans}} ></Accordion.Body>
                    </Accordion.Item>
                ))}
                </Accordion>
            ) : (
                <Card>
                    <Card.Body>
                        <Card.Title className='text-center'>
                            {appLanguage === 'hi' ? 'अभी कोई अक्सर पूछे जाने वाले प्रश्न उपलब्ध नहीं हैं!' : "There are no faq available right now."}
                        </Card.Title>
                    </Card.Body>
                </Card>
            )}
            
            </React.Fragment>
        )}
        </React.Fragment>
    );
}
export default HelpFaq;